import GenericRequest, { METHOD_DELETE } from '../../../../shared/webservices/GenericRequest';
import RouterUtils from '../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class DeleteContractorFileTask extends GenericRequest {

    _request; // DeleteContractorFileRequest

    constructor(request) {
        super(METHOD_DELETE, RouterUtils.generateRoute(ApiEndpoints.CONTRACTOR_FILES_DELETE, { id: request.id() }));
        this.request = request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/webservices/delete-documentary-library/DeleteContractorFileTask.js